.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

:host {
  display: block;
  background-color: #ffffff;
  box-sizing: border-box;
}

:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}

@media screen and (max-width: 979px) {
  :host(.in-products-filters) {
    background-color: transparent;
  }
}

@media screen and (min-width: 980px) {
  .section {
    padding: 56px 10px 72px;
    max-width: 1200px;
    margin: 0 auto;
    margin-bottom: 8px;
  }
}

@media screen and (min-width: 980px) {
  .section--with-columns {
    display: flex;
    flex-direction: row;
  }
}

@media screen and (max-width: 979px) {
  .section--in-products-filters {
    padding: 0 8px;
  }
}

.section--with-columns .section__content {
  width: 780px;
}

.section__heading {
  display: block;
}

@media screen and (min-width: 980px) {
  .section__heading {
    margin-bottom: 20px;
  }
}

@media screen and (min-width: 980px) {
  .section--with-columns .section__heading {
    width: 25%;
    max-width: 300px;
  }

  :host(:not([dir="rtl"])) .section--with-columns .section__heading {
    padding-right: 24px;
  }

  :host([dir="rtl"]) .section--with-columns .section__heading {
    padding-left: 24px;
  }
}